/**
 * @copyright © Paramount Streaming
 * @description Default API paths for the Pluto TV legacy adapter.
 */
export const PLUTO_LEGACY_API_PATHS = {
	channels: '/v2/guide/channels',
	vodItems: '/v4/vod/items',
	vodEpisodes: '/v4/vod/episodes',
	upNext: '/api/v3.2/amlg/recommendation/up-next.json',
	nextItem: '/api/v3.2/amlg/recommendation/next-item.json'
} as const;